import { PaymentPlanResponse } from '../../../../API';
import { usePlansAPI } from '../../../../hooks/API/Payments/usePlansAPI';
import { CreateDataManager, DataManagerReturnType } from '../../../DataManager';
import { PlansHook, PlansHookReturnType } from './PlansHook';
import { PlansState, PlansStateFullReturnType } from './PlansState';

export type PlansDataManagerType = {
  state: PlansStateFullReturnType;
  hook: PlansHookReturnType;
};

export interface PlansDataManagerReturnType extends DataManagerReturnType<PaymentPlanResponse, PaymentPlanResponse> {
  state: PlansStateFullReturnType;
  hook: () => PlansHookReturnType;
}

export const PlansDataManager = CreateDataManager<PaymentPlanResponse, PaymentPlanResponse, PlansDataManagerReturnType>(
  {
    name: 'plans',
    idField: 'code',
    useApiHook: usePlansAPI,
    hookInitializer: PlansHook,
    stateInitializer: PlansState,
    // Function used to generate a plan string for success & error handling
    toString: (plan: PaymentPlanResponse) => `${plan.name} (${plan.code})`
  }
);
